import React, { useState } from 'react';
import { Stack, Typography } from '@mui/material';

import { DetailViewTabList } from 'components/TabList';
import { useAuth } from 'lib/auth';
import { useLots } from '../api/getLots';
import { ExcludedRolesView } from './ExcludedRolesView';

export const excludedRolesTabName = 'excluded_roles';

export const ExcludedRolesTab = ({ currentTab, resource, id, procurementName }) => {
  const { account } = useAuth();
  const isVisible = currentTab === excludedRolesTabName && !!account?.super_admin;
  const [lotId, setLotId] = useState(null);

  const {
    data: lots,
    refetch,
    isFetchedAfterMount,
  } = useLots(resource, id, {
    enabled: isVisible,
  });
  const lot = lots.find(({ lot_id }) => lot_id === lotId) ?? lots[0];

  if (!isVisible) return null;

  if (isFetchedAfterMount && lots.length === 0) {
    return (
      <Stack flex={1} alignItems="center" justifyContent="center" gap={1} py={8}>
        <Typography variant="h5" fontWeight={700}>
          No lots yet
        </Typography>
        <Typography color="text.secondary">Add lots in Settings before excluding roles</Typography>
      </Stack>
    );
  }

  if (!lot) return null;

  return (
    <Stack gap={2}>
      <DetailViewTabList
        value={lot.lot_id}
        onChange={(_, value) => setLotId(value)}
        tabs={lots.map(({ lot_id, name }) => ({ label: name, value: lot_id }))}
        multi
      />

      <ExcludedRolesView
        key={lot.lot_id}
        resource={resource}
        id={id}
        lot={lot}
        procurementName={procurementName}
        onLotChanged={refetch}
      />
    </Stack>
  );
};
